import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  TempDocumentDetailResponseWithAny,
  useTempDocumentDetailQuery,
} from "features/document/hooks/queries/useTempDocumentDetailQuery";
import AnalysisCreateFormStep1Page from "./AnalysisCreateFormStep1Page";
import AnalysisCreateFormStep2Page from "./AnalysisCreateFormStep2Page";
import { useRecoilState } from "recoil";
import {
  analysisDocumentLevelState,
  analysisDocumentApproveStatusState,
} from "store/document/analysisDocument";
import { useFormContext } from "react-hook-form";
import { DocumentForm } from "features/document/utils/getTempSaveRequest";

const AnalysisCreateFormPage = () => {
  const tempDocumentUuid = useParams().uuid;

  const { data: tempDocumentDetail, isLoading } =
    useTempDocumentDetailQuery(tempDocumentUuid);

  /* Analysis 문서 레벨 */
  const [documentLevel, setDocumentLevel] = useRecoilState(
    analysisDocumentLevelState,
  );

  const [documentApproveStatus, setDocumentApproveStatus] = useRecoilState(
    analysisDocumentApproveStatusState,
  );

  /* 폼 */
  useAnalysisForm({ tempDocumentDetail });

  useEffect(() => {
    if (!tempDocumentDetail) return;

    setDocumentLevel(tempDocumentDetail.lastLevel);
    setDocumentApproveStatus(
      tempDocumentDetail.documentApprove?.approveStatus || null,
    );
  }, [tempDocumentDetail]);

  if (isLoading) return null;

  return documentApproveStatus === "REVIEW" && documentLevel === 1 ? (
    // 1단계 결재 문서에서 2단계 등록시
    <AnalysisCreateFormStep2Page />
  ) : documentLevel < 2 ? (
    <AnalysisCreateFormStep1Page tempDocumentDetail={tempDocumentDetail} />
  ) : (
    <AnalysisCreateFormStep2Page />
  );
};

export default AnalysisCreateFormPage;

/* Hooks */
const useAnalysisForm = ({
  tempDocumentDetail,
}: {
  tempDocumentDetail?: TempDocumentDetailResponseWithAny;
}) => {
  const methods = useFormContext<DocumentForm>();

  useEffect(() => {
    if (tempDocumentDetail) {
      const attachments =
        tempDocumentDetail.attachments?.map((attachment) => ({
          fileName: attachment.fileName,
          fileHash: attachment.md5Hash,
          documentFileUrl: attachment.fileUrl,
        })) || [];

      const referenceUsers =
        tempDocumentDetail.referenceUsers?.map((user) => user.uuid) || [];

      methods.reset({
        ...tempDocumentDetail.documentData,
        attachmentFiles: attachments,
        referenceMember: referenceUsers,
      });
    }
  }, [tempDocumentDetail]);

  return { methods };
};
